/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AnalyticsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABGElEQVR4nN2VUU7CQBCGGx48CyRKouiLgRO4OzM1aWfKZfpIefVm3EElKcEbKGRAsG5bxG0x6iaTbtPk//6dzuwEwb9ZURSdAfHUIj8DyconLPETkGSqVQLoB19hKEdWAjRxDm6gzKtOsGozAl8AIt/W/UdDybAxwFAyPFQsjQHwOdc54vjiNACU/C6MzzcFYqXfLgA/nKs4EC/8ACg5gFybML7Z7Cucq3hR8HiAk19zn3SBeOY6dwWPAzgu7XuO0zTtVInvqguRR18DCs6JuKddCcQvRONBnfh3Gu0NQC71XSH7vOtFhrIE4oft07OTLfKr5tqE8VVRHH7yqoBfC7DbYdEW4PGkA8eiTGpGpmRNTmIPjcw/u9aL/aT4e8MX7gAAAABJRU5ErkJggg==)
 */
export const AnalyticsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2 19V5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3Zm16-9.59V13a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1h-6a1 1 0 1 0 0 2h3.59l-5.09 5.09-1.8-1.8a1 1 0 0 0-1.4 0l-4 4a1 1 0 1 0 1.4 1.42L9 13.4l1.8 1.8a1 1 0 0 0 1.4 0L18 9.4Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
